import { useMemo, useEffect } from "react";
import useUserDateTime from "hooks/useUserDateTime";
import { onInitializingTimerange } from "views/components/TimerangeForForm";
import { WIDGET_DEFAULTS } from "data-lake/preview/Constants";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
const useInitialSearchBarFormValues = (executedSearch, initialUrlParams) => {
  const { formatTime } = useUserDateTime();
  const { setDataLakeFieldsFetchQuery } = useSelectedDataLake();
  const initialValues = useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (executedSearch) {
      const searchType = executedSearch.queries.first().searchTypes[0];
      return {
        table: searchType.table_id,
        timerange: onInitializingTimerange(searchType.timerange, formatTime),
        fields: {
          fieldFilters: (_a = searchType.field_filters) != null ? _a : WIDGET_DEFAULTS.fieldFilters,
          operator: (_b = searchType.filters_operator) != null ? _b : WIDGET_DEFAULTS.fieldsOperator
        }
      };
    }
    return {
      table: initialUrlParams.table,
      timerange: (_c = initialUrlParams.timerange) != null ? _c : WIDGET_DEFAULTS.timerange,
      fields: {
        fieldFilters: (_e = (_d = initialUrlParams.fields) == null ? void 0 : _d.fieldFilters) != null ? _e : WIDGET_DEFAULTS.fieldFilters,
        operator: (_g = (_f = initialUrlParams.fields) == null ? void 0 : _f.operator) != null ? _g : WIDGET_DEFAULTS.fieldsOperator
      }
    };
  }, [executedSearch, formatTime, initialUrlParams.fields, initialUrlParams.table, initialUrlParams.timerange]);
  useEffect(() => {
    if (initialValues == null ? void 0 : initialValues.table) {
      setDataLakeFieldsFetchQuery((cur) => ({ ...cur, tableId: initialValues.table }));
    }
  }, [initialValues.table, setDataLakeFieldsFetchQuery]);
  return initialValues;
};
export default useInitialSearchBarFormValues;
